<template>
  <div>
    <div class="invoiceList">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="primary white--text" style="margin-top: 10px">
            <v-flex xs12 md3>
              <v-switch
                v-model="showOptions"
                color="white"
                class="white-switch"
                :label="`${showOptions ? 'Hide Options' : 'Show Options'}`"
              ></v-switch>
            </v-flex>
            <template v-if="showOptions">
              <v-flex xs12 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="white-datepicker"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="datepickerFrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo"
                  :nudge-right="40"
                  lazy
                  class="white-datepicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateTo"
                    @input="datepickerTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <router-link to="/Dashboard">
                  <v-btn icon dark class="primary white--text" style="float: right">
                    <v-icon>close</v-icon>
                  </v-btn>
                </router-link>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 md4>
                <h3 class="title text-xs-center ">BANK TRANSACTIONS</h3>
              </v-flex>
              <v-flex xs12 md2>
                <h3 class="title text-xs-center ">Balance : ₹ {{Number.parseFloat(totalDebit - totalCredit).toFixed(2)}}</h3>
              </v-flex>
              <v-flex xs12 md3>
                <router-link to="/Dashboard">
                  <v-btn icon dark class="primary white--text" style="float: right">
                    <v-icon>close</v-icon>
                  </v-btn>
                </router-link>
                <v-btn
                  icon 
                  dark
                  @click="print()"
                  class="primary white--text"
                  style="float: right">
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </v-flex>
            </template>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <!-- <v-data-table :items="invoicesByBrand" class="elevation" :headers="headers"> -->
      <v-data-table
        :items="invoicesByBrand"
        class="elevation transaction-table"
        :pagination.sync="pagination"
        :headers="headers"
      >
        <template slot="items" slot-scope="props">
          <automatic-invoice
             v-if='props.item.type == "automatic invoice" && props.item.firm != "Total"'
            :item="props.item"
            :firms="firms"
          />
          <normal-invoice
             v-if='props.item.type != "automatic invoice" && props.item.firm != "Total"'
            :item="props.item"
            :firms="firms"
            :buyers="buyers"
            :sellers="sellers"
          />
           <tr v-if='props.item.firm == "Total"'>
                    <td><b class="font-weight-bold primary--text">Total</b></td>
                    <td><b class="font-weight-bold" ></b></td>
                    <template>    
                    
                    <td class="credit-total"> <b class="green--text font-weight-bold "> {{props.item.credit || 0 | amount }} </b></td>
                    <td class="debit-total"> <b class="red--text font-weight-bold "> {{props.item.debit || 0 | amount}} </b></td>        
                    </template>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                </tr>
        </template>
        <template slot="no-data">No rows to Show</template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

import { convertToPDFTransactionReportFirm } from "../../utils/pdf-reports/transaction-reports";

import { DateTime, Interval } from "luxon";
import normalInvoice from "./normalInvoice";
import automaticInvoice from "./automaticInvoice";

export default {
  components: {
    normalInvoice,
    automaticInvoice,
  },
  data: () => ({
    headers: [
      { text: "Date", value: "date", sortable: false },
      { text: "Customer Name", value: "expense", sortable: false },
      { text: "Debit", value: "category", sortable: false },
      { text: "Credit", value: "underHead", sortable: false },
      { text: "Voucher type", value: "totalAmount", sortable: false },
      { text: "Payment type", value: "totalAmount", sortable: false },
      // { text: "Transaction type", value: "totalAmount", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Remark", sortable: false },
    ],
    pagination: {
      rowsPerPage: -1, // -1 for All",
    },
    totalCredit : 0,
    totalDebit : 0,
    showOptions: false,
    dateFrom: null,
    dateTo: null,
    datepickerFrom: false,
    datepickerTo: false,
  }),
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments",this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('bankAccountById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    if(this.finYear) {
        this.dateFrom = this.formatDate(this.finYear.start);
        this.dateTo = this.formatDate(this.finYear.end);
    }
    this.selectedBank = this.$route.params.bankId;
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    invoicesByBrand() {
      let invoiceHistory  =  this.invoiceHistory.filter((item) => 
                item['brand'] === this.selectedBrand && 
                // this.status.indexOf(item['status']) !== -1 && 
                // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
                ((this.selectedBank) ? (item['bank'] === this.selectedBank): false) &&
                (item['paymentType'] !='Cash') &&
                // (item['status'] ==='paid'||'partial') &&
                (item['status'] !='due') &&
                (item.deleted != true) &&
                // ((item.date >= new Date(this.dateFrom).getTime()) && (item.date <= new Date(this.dateTo).getTime()))
                (item.closedDate ? 
                ((item.closedDate >= new Date(this.dateFrom).getTime()) && (item.closedDate <= new Date(this.dateTo).getTime())) : 
                ((item.date >= new Date(this.dateFrom).getTime()) && (item.date <= new Date(this.dateTo).getTime())))
                && (item['isLatest'] != undefined ? item['isLatest'] == true : true)
        )
      // invoiceHistory.map((item) => {
      //   if (
      //     item.newlyCreated &&
      //     (item.status === "paid" || item.status === "partial")
      //   ) {
      //     let newItem = JSON.parse(JSON.stringify(item));
      //     newItem.date = newItem.date - 1;
      //     newItem.transactionType = "Debit";
      //     newItem.paidAmount = 0;
      //     newItem.status = "due";
      //     newItem.remainingAmount = newItem.totalAmount;
      //     delete newItem["newlyCreated"];
      //     invoiceHistory.push(newItem);
      //   }
      // }
      // );
      let invoice = this.invoices.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item.type == "automatic invoice" &&
          (item.deleted != true) &&
         ((this.selectedBank) ? (item['bank'] === this.selectedBank): false) &&
          item.date >= new Date(this.dateFrom).getTime() &&
          item.date <= new Date(this.dateTo).getTime() &&
          (item["isLatest"] != undefined ? item["isLatest"] == true : true)
      );

      let customerDeposit = this.deposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
         ((this.selectedBank) ? (item['bank'] === this.selectedBank): false) &&
          item.date >= new Date(this.dateFrom).getTime() &&
          item.date <= new Date(this.dateTo).getTime() &&
          (item["type"] === "Advance" ||
            item["type"] === "Opening Balance" ||
            item["type"] === "LoanTaken" ||
            item["type"] === "LoanGiven" ||
            item["type"] === "Security")
      );
      customerDeposit.map((deposit) => {
        invoice.push(deposit);
        if (
          (deposit["type"] === "LoanTaken" ||
            deposit["type"] === "LoanGiven") &&
          deposit.status == "paid"
        ) {
          let temp = JSON.parse(JSON.stringify(deposit));
          temp.status = "due";
          invoice.push(temp);
        }
      });
      let payments  = this.customerPayments.filter(
           item =>
           item["brand"] === this.selectedBrand &&
           ((this.selectedBank) ? (item['bank'] === this.selectedBank): false) &&
           (Number.parseFloat(item["remainingAmount"]) > 0) &&
           ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false)
      );
      payments.map((pay)=>{
           pay['type'] = 'CustomerPayment'
           invoice.push(pay)
      })

      let bankAccountById = this.bankAccountById.filter(item => item['.key'] == this.selectedBank)[0];
       console.log(bankAccountById)
        if(bankAccountById && bankAccountById.openingBalance) {
           invoice.push({
            status:'Bank Opening Balance',
            openingBalance : bankAccountById.openingBalance,
            date : bankAccountById.openingDate
          })
        }
       
      setTimeout(() => {
          this.getTotal()
      }, 800);
      invoice = invoice.concat(invoiceHistory);

      invoice.map((item,index)=>{
        if(item.type != 'automatic invoice' && item.closedDate) {
          invoice[index]['date'] = item.closedDate;
        }
      })
      // invoice = invoice.concat(invoiceHistory);
      invoice.sort((a, b) => (a.date > b.date) ? 1 : -1)
      invoice.push({
                firm : 'Total'
            })
      return invoice;
    },
  },
  methods: {
    getTotal(){
              const tableElement = document.querySelector('.transaction-table table');
                if(tableElement) {
                        const thead = tableElement.querySelector('thead');
                        const tbody = tableElement.querySelector('tbody');
                        // Assumes there's only one header row
                        const columns = thead.querySelectorAll('tr th');
                        const columnNames = [];
                        columns.forEach( c => columnNames.push(c.innerText));
                        const result = [];
                        const bodyRows = tbody.querySelectorAll('tr');
                        bodyRows.forEach( r => {
                            const tds = r.querySelectorAll('td');
                            const arr = [];
                            tds.forEach( (td, idx) => {
                            arr.push(td.innerText);
                            if(td.classList.contains("credit-total")) {
                                let total = 0;
                                result.map((a)=>{
                                    if(a[0]!='Total') {
                                        let amount  = Number.parseFloat(0+a[2].replaceAll(",",""));
                                        total += amount
                                    }
                                }) 
                                this.totalCredit = Number.parseFloat(total);
                                td.querySelector("b").innerHTML = Number.parseFloat(total).toFixed(2);
                            }
                            if(td.classList.contains("debit-total")) {
                                let total = 0;
                                result.map((a)=>{
                                    if(a[0]!='Total') {
                                        let amount  = Number.parseFloat(0+a[3].replaceAll(",",""));
                                        total += amount
                                    }
                                }) 
                                this.totalDebit = Number.parseFloat(total);
                                td.querySelector("b").innerHTML = Number.parseFloat(total).toFixed(2);
                            }
                            });
                            result.push(arr);
                        });
                    return result;
                }
                // let total = 0;
                //     invoices.map((a)=>{
                //         if(a[0]!='Total') {
                //             let amount  = isCredit ? Number.parseFloat(0+a[2].replaceAll(",","")) : Number.parseFloat(0+a[3].replaceAll(",",""))
                //             total += amount
                //         }

                //     })
                //     return total;
                    
            },
             htmlToArray  () {
                const tableElement = document.querySelector('.transaction-table table');
                if(tableElement) {
                        const thead = tableElement.querySelector('thead');
                        const tbody = tableElement.querySelector('tbody');
                        // Assumes there's only one header row
                        const columns = thead.querySelectorAll('tr th');
                        const columnNames = [];
                        columns.forEach( c => columnNames.push(c.innerText));
                        const result = [];
                        const bodyRows = tbody.querySelectorAll('tr');
                        bodyRows.forEach( r => {
                            const tds = r.querySelectorAll('td');
                            const arr = [];
                            tds.forEach( (td, idx) => {
                            arr.push(td.innerText);
                            });
                            result.push(arr);
                        });
                    return result;
                }
                return [];
            },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    print() {
      this.pagination.rowsPerPage = -1;
      setTimeout(() => {
        this.printInvoices();
      }, 1000);
    },
    printInvoices() {
      const htmlToArray = (tableElement) => {
        const thead = tableElement.querySelector("thead");
        const tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        const columns = thead.querySelectorAll("tr th");
        const columnNames = [];
        columns.forEach((c) => columnNames.push(c.innerText));
        const result = [];
        const bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach((r) => {
          const tds = r.querySelectorAll("td");
          const arr = [];
          tds.forEach((td, idx) => {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };

      const table = document.querySelector(".transaction-table table");
      let invoices = htmlToArray(table);
      let bank = this.bankAccountById.find(item => item['.key'] == this.selectedBank)
      let doc = convertToPDFTransactionReportFirm({
        invoiceData: invoices,
        bank: this.selectedBank ? bank.bankName : '',
        dateFrom: new Date(this.dateFrom).toLocaleDateString("en-GB"),
        dateTo: new Date(this.dateTo).toLocaleDateString("en-GB"),
      });
      pdfMake.createPdf(doc).download(bank.bankName + '_Bank_Statement' );
    },
  },
};
</script>

<style>
.flexColumn {
  flex-direction: column;
  align-items: flex-start;
}
.theme--light .white-switch {
  margin-top: 25px;
}

.theme--light .white-switch .v-label {
  color: white;
}

.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}

.white-datepicker .v-input__slot:before {
  border-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BankStatements/invoiceList.vue